import { JsSearch } from "../types/JsQuery";
import { jqh } from "./common";

export default function tagsQuery(tag_ids?: string[]): JsSearch {
  if (!tag_ids?.length) return {};
  return { "tags.tag_id": jqh.in(tag_ids) };
}
